// Centralized Firestore collection names
export const COLLECTIONS = {
  COMPANIES: 'companies',
  USERS: 'users',
  USER_PRIVATE_RATES: 'userPrivateRates',
  TASK_CATEGORIES: 'taskCategories',
  // Admin-managed task labels (rush, rework, training, etc.).
  TASK_TAGS: 'taskTags',
  PRODUCTION_TASKS: 'productionTasks',
  PRODUCTION_AREAS: 'productionAreas',
  SETTINGS: 'settings',
  // Admin-only: hourly rates config, labour cost currency.
  // Production users cannot read this collection.
  ADMIN_SETTINGS: 'adminSettings',
  ACTIVITY_LOGS: 'activityLogs',
  FEEDBACK: 'feedback',
  // Named floor workers (no auth account) — non-sensitive identity (name,
  // active). Readable by all active company users for the assignment picker.
  FLOOR_WORKERS: 'floorWorkers',
  // Per-floor-worker hourly rate (doc ID == floorWorkers doc ID). Admin-only;
  // production users cannot read this collection.
  FLOOR_WORKER_RATES: 'floorWorkerRates',
  // Structured task notes — category + optional text, linked to a task.
  // Both production users (own tasks) and admins (all company tasks) can add/read.
  TASK_NOTES: 'taskNotes',
  // Admin-saved analytics filter views (per company).
  ANALYTICS_VIEWS: 'analyticsViews',
  // Append-only production lifecycle events for Production Replay.
  PRODUCTION_EVENTS: 'productionEvents',
};
